{
  "menu": {
    "home": "ГЛАВНАЯ",
    "programs": "ПРОГРАММЫ",
    "residency": "ВНЖ",
    "citizenship": "Паспорт и гражданство",
    "about": "О НАС",
    "aboutShort": "О НАС",
    "partnership": "ПАРТНЁРЫ",
    "education": "ОБРАЗОВАНИЕ",
    "news": "АНАЛИТИКА",
    "contact": "КОНТАКТ"
  },
  "footer": {
    "copyright": "© 2026 Pacific Link International. All rights reserved.",
    "abn": "Australia · ABN 99 673 671 184",
    "quickLinks": "Быстрые ссылки",
    "immigrationSite": "Иммиграционные программы",
    "educationSite": "Онлайн-программы степеней",
    "legal": "Правовая информация",
    "legalNotice": "Юридическое уведомление",
    "privacyPolicy": "Политика конфиденциальности",
    "termsOfUse": "Условия использования"
  }
}
